module.exports = __webpack_public_path__ + "img/hr-green-asterisk-04.d0a4ecff.png";